export class Company {
    companyName: any;
}
